import React from "react";
import close from "../../../assets/images/model/close.svg"; // Update the path accordingly
const TroubleModel = ({
  setSelectChapter,
  setTroubleModel,
  setThanksModel,
  setSupportModel,
}) => {
  return (
    <div
      className="modal custom_background custom_modal_create"
      id="confirm_authors"
      tabIndex="-1"
      style={{ display: "block" }}
      aria-labelledby="confirm_authorsLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <img
                src={close}
                alt="close"
                onClick={() => {
                  setThanksModel(false);
                  setTroubleModel(false);
                }}
              />
            </button>
          </div>
          <div className="modal-body-cre">
            <h4>trouble with upload?</h4>
            <p>
              How can we help? Select an option and someone from Greyled will
              reach out to you within the same day to assist.
            </p>
            <form action="" className="confirm_authors">
              <div className="confirm_authors my-40">
                <div className="check_box_wrap d-inline radio_wrap_box">
                  <div className="iagree_radio_create">
                    <input
                      type="radio"
                      name="Missing_chapters"
                      id="Missing_chapters"
                      className=""
                    />
                    <label for="Missing_chapters">
                      Missing chapters or sections
                    </label>
                  </div>
                  <div className="iagree_radio_create">
                    <input
                      type="radio"
                      name="Missing_chapters"
                      id="General_help"
                      className=""
                    />
                    <label for="General_help">
                      General help with greyled<span>create</span>
                    </label>
                  </div>
                  <div className="iagree_radio_create">
                    <input
                      type="radio"
                      name="Missing_chapters"
                      id="Other"
                      className=""
                    />
                    <label for="Other">Other</label>
                  </div>
                </div>
              </div>
              <div className="modal-btn">
                <button
                  type="button"
                  className="btn-black_create mb-24"
                  onClick={() => {
                    setSupportModel(true);
                    setTroubleModel(false);
                  }}
                >
                  Send email to Greyled support
                </button>
                <button
                  type="button"
                  className="btn-white-create"
                  onClick={() => {
                    setSelectChapter(true);
                    setTroubleModel(false);
                  }}
                >
                  Go back
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TroubleModel;
